import Vue from 'vue'
import Vuex from 'vuex'
import * as API from "../api/global"

import { getMenuId } from "../utils/getMenuId"
import i18n from "@/locales/i18n.js";
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        routerList:sessionStorage.getItem('routerList') ? JSON.parse(sessionStorage.getItem('routerList')):[{title:i18n.t('menu_index'),name:'home/desk.vue',path:'/home/desk.vue'}],
        adminInfo: {},
        menuList: [],
        activeIndex:sessionStorage.getItem('activeIndex') ?sessionStorage.getItem('activeIndex') :"home/desk.vue",
        isLogin:false,//登陆状态
    },
    mutations: {
        //改变登陆状态
        changeLogin(state, data){
            state.isLogin=data
            console.log('isLogin'+data)
            // console.log(sessionStorage.getItem('routerList'),'.......')
        },
        // 设置当前**的tab
        set_active_index (state, index) {
            state.activeIndex = index;
            sessionStorage.setItem("activeIndex",index);
        },
        set_routerList_clear:(state,view)=> {
            state.routerList=[];
            state.routerList.push(
                Object.assign({},view,{
                    title:view.meta.title || 'no-name'
                })

            )
            let str=JSON.stringify(state.routerList);
            sessionStorage.setItem('routerList', str);
        },
        //新增tag标签
        ADD_VISITED_VIEW:(state,view)=>{
            if(state.routerList.some(v=>v.path === view.path)) return
            state.routerList.push(
                Object.assign({},view,{
                    title:view.meta.title || 'no-name'
                })

            )
            let str=JSON.stringify(state.routerList);
            sessionStorage.setItem('routerList', str);
            // state.activeIndex=view.name;

        },
        DEL_VISITED_VIEW:(state,view)=>{
            for (const[i,v] of state.routerList.entries()){
                if(v.path==view.path){
                    if (state.activeIndex==v.name) state.activeIndex=state.routerList[i -1].name;
                    state.routerList.splice(i,1);
                    let str=JSON.stringify(state.routerList);
                    sessionStorage.setItem('routerList', str);
                    break
                }
            }
        },

        changeState(state, payload) {
            let { stateList, key, value } = payload
            if (stateList) {
                stateList.map(item => {
                    state[item.key] = item.value
                })
            } else {
                state[key] = value
            }
        }
    },
    actions: {

        async getSysPonsitionMenuOperation({ state, commit, dispatch }) {
            let param = {
                i_uid:sessionStorage.getItem('userid'),
                token:sessionStorage.getItem('token'),
                app: 'masterdata',
                version: "1.0"
            };
            let res = await API.getMenuoperation(param)
            if(res.code==1){
                commit("changeState", { key: 'menuList', value: res.menuList || [] })
                return res
            }else if(res.code==-2){
                this.$router.push('/login')
                this.$message.error(res.message);
            }
        },
        getCurrentMenuId({ state }, payload) {
            let res = getMenuId(payload.path, state.menuList);
            return res
        },

    },
    modules: {
    }
})



